import React, { FC } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Dispatch } from '@reduxjs/toolkit';

import type { ReduxState } from 'app/redux/types';

import { useTranslation } from 'app/lang';
import { accountFirstName } from 'app/lib/account/selectors';
import { isUsernameHidden } from 'app/lib/site-configs/selectors';
import { changeConfigValue } from 'app/lib/site-configs/slice';

import dictionary from './HiddenAccountNameItem.dictionary.json';

import styles from './HiddenAccountNameItem.module.scss';

type StoreProps = {
  isUsernameHidden: boolean;
  userFirstName?: string;
};

type HiddenAccountNameItemProps = {
  dispatch: Dispatch;
  onClick: () => void;
} & StoreProps;

const HiddenAccountNameItem: FC<HiddenAccountNameItemProps> = ({
  isUsernameHidden,
  dispatch,
  userFirstName,
  onClick,
}) => {
  const { t } = useTranslation();

  const handleInfoHiddenClick = () => {
    dispatch(changeConfigValue({ name: 'isUsernameHidden', value: !isUsernameHidden }));
  };

  const hiddenText = isUsernameHidden
    ? t(dictionary.showHiddenText)
    : t(dictionary.hiddenText);

  return (
    <li data-test="accountInfo-accountName"
        className={styles.containerLogout}>
      <Link to="/personal"
            onClick={onClick}
            className={styles.userName}
            data-ga-event="header-cabinet"
            data-ga-event-value="nameClick"
            title={userFirstName}>
        {userFirstName}
      </Link>
      <button type="button"
              className={styles.buttonHidden}
              title={t(dictionary.buttonTitle)}
              data-ga-event="header-balanceToggle"
              data-ga-event-value={isUsernameHidden ? 'On' : 'Off'}
              onClick={handleInfoHiddenClick}>
        {hiddenText}
      </button>
    </li>
  );
};

const mapStateToProps = (state: ReduxState): StoreProps => ({
  isUsernameHidden: isUsernameHidden(state),
  userFirstName: accountFirstName(state),
});

export default connect(mapStateToProps)(HiddenAccountNameItem);
